import { Button, Card, Input } from "antd";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router";
import { useAppDispatch } from "../../../../app/app.store";
import {
  useRequestOtpMutation,
  useVerifyOtpMutation,
} from "../../../../app/features/auth/auth.api";
import { verifyUser } from "../../../../app/features/auth/auth.slice";
import { errorToast } from "../../../../utils/error.utils";

export default function RegisterOtpCard() {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useAppDispatch();
  const [otp, setOtp] = useState("");
  const phone = location.state?.phone;
  const email = location.state?.email;
  const otpChannel = location.state?.otpChannel;

  // API hooks
  const [verifyOtp, { isLoading: isVerifying }] = useVerifyOtpMutation();
  const [requestOtp, { isLoading: isResending }] = useRequestOtpMutation();

  // Timer state
  const [timeLeft, setTimeLeft] = useState(120);
  const [canResend, setCanResend] = useState(false);

  // Timer logic
  useEffect(() => {
    if (timeLeft > 0) {
      const timerId = setTimeout(() => setTimeLeft(timeLeft - 1), 1000);
      return () => clearTimeout(timerId);
    } else {
      setCanResend(true);
    }
  }, [timeLeft]);

  const formatTime = (seconds: number) => {
    const min = Math.floor(seconds / 60);
    const sec = seconds % 60;
    return `${min}:${sec < 10 ? "0" : ""}${sec}`;
  };

  const handleChange = (value: string) => {
    setOtp(value);
  };

  const handleSubmit = async () => {
    // || !email
    // TODO: phone
    if (!email || !otp) return;
    try {
      const res = await verifyOtp({ email, phone, otp, otpChannel }).unwrap();
      if (res.accessToken) {
        dispatch(
          verifyUser({
            accessToken: res.accessToken,
            refreshToken: res.refreshToken,
          })
        );
        navigate("/user/dashboard");
      }
    } catch (error) {
      errorToast(error, "OTP ভেরিফিকেশন ব্যর্থ হয়েছে");
    }
  };

  const handleResendOtp = async () => {
    // TODO: phone
    if (!email) return;
    try {
      await requestOtp({ email, phone, otpChannel }).unwrap();
      setTimeLeft(120);
      setCanResend(false);
    } catch (error) {
      errorToast(error, "OTP পাঠান যায়নি");
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center">
      <Card className="!w-96 shadow-lg sm:w-11/12" bordered={true}>
        <div className="text-theme-zinc-700 text-xl font-semibold mb-4">
          OTP ভেরিফিকেশন
        </div>

        {/* <div className="justify-start text-slate-600 text-sm font-normal mb-6">
          OTP ভেরিফিকেশনের জন্য {phone} নম্বরে ৬ সংখ্যার OTP পাঠানো হয়েছে,
          ইনবক্স/এসএমএস দেখুন{" "}
        </div> */}
        <div className="justify-start text-slate-600 text-sm font-normal mb-6">
          OTP ভেরিফিকেশনের জন্য {otpChannel === "phone" ? phone : email} এ ৬ সংখ্যার OTP পাঠানো হয়েছে,
          ইনবক্স/এসএমএস দেখুন{" "}
        </div>

        {/* Ant Design OTP Input */}
        <div className="mb-6">
          <Input.OTP
            value={otp}
            onChange={handleChange}
            length={6}
            autoFocus
            size="large"
            className="!gap-3 !justify-center"
          />
        </div>

        <div className="flex justify-between items-center mb-6">
          <Button
            type="link"
            disabled={!canResend || isResending}
            onClick={handleResendOtp}
            className="p-0 text-blue-600 font-normal"
          >
            {isResending ? "পাঠানো হচ্ছে..." : "পুনরায় OTP পাঠান"}
          </Button>
          {!canResend && (
            <span className="text-slate-500">
              {formatTime(timeLeft)} পরে আবার চেষ্টা করুন
            </span>
          )}
        </div>

        <Button
          type="primary"
          onClick={handleSubmit}
          loading={isVerifying}
          block
          size="large"
          className="pt-2"
        >
          সাবমিট করুন
        </Button>
      </Card>
    </div>
  );
}
